import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-help-me-popup',
  templateUrl: './help-me-popup.component.html',
  standalone: false,
})
export class HelpMePopupComponent {
  public sessionId: string = '';
  public isSupport: boolean = false;
  public pendingInvite: boolean = false;
  public sessionEnded: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<HelpMePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    // a couple of ways to do this:
    // 1) check current role
    // 2) pass in a role

    // if current user is support and there's no session id -> prompt to start session
    this.isSupport = data.isSupport;

    //if (this.sessionId != undefined && data.sessionId != "") {
    this.sessionId = data.sessionId;
    //}

    if (data.pendingInvite == true) {
      this.pendingInvite = true;
    }

    if (data.sessionEnded) {
      this.sessionEnded = true;
    }
  }

  public btnClose_click() {
    this.closeDialog(null);
  }

  public btnEndSession_click() {
    this.endSession();
  }

  public btnRequestSession_click() {
    this.requestSession();
  }

  public btnAcceptSession_click() {
    this.acceptInvite();
  }

  private acceptInvite() {
    this.closeDialog('AcceptInvite');
  }

  private endSession() {
    this.sessionId = '';
    this.closeDialog('EndSession');
  }

  private requestSession() {
    this.closeDialog('RequestSession');
  }

  private closeDialog(action: string | null) {
    this.dialogRef.close({ event: action });
  }
}
